'use client';

import { parseISO } from 'date-fns';

import { formatDatetime } from '@flipster/utils/datetime';
import { useMounted } from '@flipster/react/misc/lifecycle/mount';

interface Props {
  dateString?: string;
  formatter?: string;
  className?: string;
}

// 날짜라서 서버 빌드시 불일치
const BlogDateTime = ({ dateString, formatter = 'LLLL	d, yyyy', className }: Props) => {
  const isMounted = useMounted();

  if (!isMounted) return null;
  if (!dateString) return <span className={className}>unknown</span>;

  const date = parseISO(dateString);

  return (
    <time dateTime={dateString} className={className}>
      {formatDatetime(date, { format: formatter })}
    </time>
  );
};

export default BlogDateTime;
